import { HttpErrorResponse } from '@angular/common/http';

/**
 * Modelo tipado de erro da API. Cobre 3 formatos:
 *  - Hierarquia v2 (novo): { erro, mensagem, detalhes }
 *  - Legado app: { mensagem }
 *  - Spring default: { timestamp, status, error, path, message? }
 */
export interface ApiError {
  codigo: string;                       // ex: "TIME_FORA_DO_DEPARTAMENTO" ou "UNKNOWN"
  mensagem: string;
  detalhes: Record<string, unknown>;    // sempre objeto (nunca null)
  httpStatus: number;
}

export function apiErrorFromHttpErrorResponse(err: HttpErrorResponse): ApiError {
  const body: Record<string, unknown> =
    err.error && typeof err.error === 'object' ? (err.error as Record<string, unknown>) : {};

  // Formato novo Hierarquia v2: { erro, mensagem, detalhes }
  if ('erro' in body) {
    return {
      codigo: String(body['erro']),
      mensagem: String(body['mensagem'] ?? err.message ?? 'Erro desconhecido'),
      detalhes: (body['detalhes'] ?? {}) as Record<string, unknown>,
      httpStatus: err.status,
    };
  }
  // Formato legado: { mensagem }
  if ('mensagem' in body) {
    return {
      codigo: 'UNKNOWN',
      mensagem: String(body['mensagem']),
      detalhes: {},
      httpStatus: err.status,
    };
  }
  // Spring default: { timestamp, status, error, path, message? }
  if ('timestamp' in body || 'error' in body) {
    return {
      codigo: 'UNKNOWN',
      mensagem: String(body['message'] ?? body['error'] ?? err.message ?? 'Erro desconhecido'),
      detalhes: { path: body['path'], timestamp: body['timestamp'] },
      httpStatus: err.status,
    };
  }
  // Fallback
  return {
    codigo: 'UNKNOWN',
    mensagem: err.message ?? 'Erro desconhecido',
    detalhes: {},
    httpStatus: err.status,
  };
}
